// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.s-canvas{\n    width: 120px;\n    height:50px;\n    cursor: pointer;\n}\n#s-canvas{border-radius: 0;}\n", ""]);
// Exports
module.exports = exports;
